import { refreshFirebaseToken } from "../features/authentication/clients/firebase/FirebaseAuthProvider";

let activityTimer: ReturnType<typeof setTimeout> | null = null;

const ACTIVITY_EVENTS = [
  "mousemove",
  "keydown",
  "click",
  "scroll",
  "touchstart"
];

function resetActivityTimer() {
  if (activityTimer) clearTimeout(activityTimer);

  // Refresh after 30 minutes of ongoing activity
  activityTimer = setTimeout(() => {
    refreshFirebaseToken();
  }, 30 * 60 * 1000);
}

export function startUserActivityTracking() {
  ACTIVITY_EVENTS.forEach(event => {
    window.addEventListener(event, resetActivityTimer);
  });

  resetActivityTimer(); // Start immediately
}